export let AgMemberModalFieldsJSON = {
  "1718617002793-customDate": {
    elementid: 1718617002793,
    elementtype: "customDate",
    // "display-required": 1,
    "database-label": "birth_date",
    "display-fieldlabel": "Date of birth",
    "display-labelposition": "top",
    "display-placeholder": "date",
    allowFutureDates: 0,
    // "display-required": 1,
  },
  "1718616994627-customSelect": {
    elementid: 1718616994627,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "Male#Female#Other",
    "database-label": "gender",
    "display-fieldlabel": "Gender",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
  },
  "1718617024542-number": {
    elementid: 1718617024542,
    elementtype: "number",
    "display-fieldlabel": "Pincode ",
    "database-label": "pincode",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961245-columns": {
    elementid: 1718616961245,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616967444-textfield": {
    elementid: 1718616967444,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Full Name",
    "database-label": "name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  // "1718616970411-textfield": {
  //   elementid: 1718616970411,
  //   elementtype: "textfield",
  //   "display-required": 1,
  //   "display-fieldlabel": "Last Name",
  //   "database-label": "last_name",
  //   "validation-maxlength": "2000",
  //   "validation-minlength": "0",
  //   "display-labelposition": "top",
  //   "display-placeholder": "Enter",
  //   "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  // },
  "1718616976561-email": {
    elementid: 1718616976561,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email id",
    "database-label": "email_id",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
    // "display-disabled": 1,
  },
  "1718617011709-textfield": {
    elementid: 1718617011709,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 1",
    "database-label": "address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617014275-textfield": {
    elementid: 1718617014275,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 2",
    "database-label": "address2",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617031258-textfield": {
    elementid: 1718617031258,
    elementtype: "textfield",
    "display-fieldlabel": "Customer Code",
    "database-label": "emp_code",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "display-fieldlabel": "State",
    "database-label": "state",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617041258-textfield": {
    elementid: 1718617041258,
    elementtype: "textfield",
    "display-fieldlabel": "City",
    "database-label": "city",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616984561-phoneNumber": {
    elementid: 1718616984561,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Mobile No.",
    "database-label": "contact",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
    "display-required": 1,
    // "display-disabled": 1,
  },
  // "1718616994611-customSelect": {
  //   elementid: 1718616994611,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": [],
  //   "database-label": "relationship_manager",
  //   "display-fieldlabel": "Relationship Manager",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  "1718616994611-customSelect": {
    elementid: 1718616994611,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "display-fieldlabel": "Relationship Manager",
    "database-label": "rm_id",
    // "validation-maxlength": "2000",
    // "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-placeholder": "Select",
    "display-required": 1,
  },
  "1718616994899-customSelect": {
    elementid: 1718616994899,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "database-label": "status",
    // "validation-maxlength": "2000",
    // "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Select",
  },
};

export let AgMemberEditModalFieldsJSON = {
  "1718617002793-customDate": {
    elementid: 1718617002793,
    elementtype: "customDate",
    // "display-required": 1,
    "database-label": "birth_date",
    "display-fieldlabel": "Date of birth",
    "display-labelposition": "top",
    "display-placeholder": "date",
    allowFutureDates: 0,
  },
  "1718616994627-customSelect": {
    elementid: 1718616994627,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "Male#Female#Other",
    "database-label": "gender",
    "display-fieldlabel": "Gender",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
  },
  "1718617024542-number": {
    elementid: 1718617024542,
    elementtype: "number",
    "display-fieldlabel": "Pincode ",
    "database-label": "pincode",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961245-columns": {
    elementid: 1718616961245,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616967444-textfield": {
    elementid: 1718616967444,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Full Name",
    "database-label": "name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  // "1718616970411-textfield": {
  //   elementid: 1718616970411,
  //   elementtype: "textfield",
  //   "display-required": 1,
  //   "display-fieldlabel": "Last Name",
  //   "database-label": "last_name",
  //   "validation-maxlength": "2000",
  //   "validation-minlength": "0",
  //   "display-labelposition": "top",
  //   "display-placeholder": "Enter",
  //   "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  // },
  "1718616976561-email": {
    elementid: 1718616976561,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email id",
    "database-label": "email_id",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
    "display-disabled": 1,
  },
  "1718617011709-textfield": {
    elementid: 1718617011709,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 1",
    "database-label": "address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617014275-textfield": {
    elementid: 1718617014275,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 2",
    "database-label": "address2",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617031258-textfield": {
    elementid: 1718617031258,
    elementtype: "textfield",
    "display-fieldlabel": "Customer Code",
    "database-label": "emp_code",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "display-fieldlabel": "State",
    "database-label": "state",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617041258-textfield": {
    elementid: 1718617041258,
    elementtype: "textfield",
    "display-fieldlabel": "City",
    "database-label": "city",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616984561-phoneNumber": {
    elementid: 1718616984561,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Mobile No.",
    "database-label": "contact",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
    "display-required": 1,
    "display-disabled": 1,
  },
  // "1718616994611-customSelect": {
  //   elementid: 1718616994611,
  //   elementtype: "customSelect",
  //   "data-datasource": "customvalues",
  //   "data-customvalue": [],
  //   "database-label": "relationship_manager",
  //   "display-fieldlabel": "Relationship Manager",
  //   "display-noofcolumns": "2",
  //   "display-labelposition": "top",
  // },
  "1718616994611-customSelect": {
    elementid: 1718616994611,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": [],
    "display-fieldlabel": "Relationship Manager",
    "database-label": "rm_id",
    // "validation-maxlength": "2000",
    // "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "display-placeholder": "Select",
  },
  "1718616994899-customSelect": {
    elementid: 1718616994899,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "database-label": "status",
    // "validation-maxlength": "2000",
    // "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Select",
  },
};

export let PrimaryDetailsModalFieldsJSON = {
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616976561-email": {
    elementid: 1718616976561,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email id",
    "database-label": "email_id",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+.[a-zA-Z]{2,}$",
  },
  "1718616970411-phoneNumber": {
    elementid: 1718616970411,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Mobile No.",
    "database-label": "contact",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
    "display-required": 1,
  },
};

export let AgFamilyMemberModalFieldsJSON = {
  "1718617002793-customDate": {
    elementid: 1718617002793,
    elementtype: "customDate",
    "display-required": 1,
    "database-label": "birth_date",
    "display-fieldlabel": "Date of birth",
    "display-labelposition": "top",
    "display-placeholder": "Date",
  },
  "1718616994627-customSelect": {
    elementid: 1718616994627,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "data-customvalue": "MALE#FEMALE",
    "database-label": "gender",
    "display-fieldlabel": "Gender",
    "display-placeholder": "Select",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
  },
  "1718617024542-number": {
    elementid: 1718617024542,
    elementtype: "number",
    "display-fieldlabel": "Pincode ",
    "database-label": "pincode",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616922481-columns": {
    elementid: 1718616922481,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616936763-columns": {
    elementid: 1718616936763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616939763-columns": {
    elementid: 1718616939763,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616942462-columns": {
    elementid: 1718616942462,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616955479-columns": {
    elementid: 1718616955479,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616961228-columns": {
    elementid: 1718616961228,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1718616967444-textfield": {
    elementid: 1718616967444,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "First Name",
    "database-label": "first_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1718616970411-textfield": {
    elementid: 1718616970411,
    elementtype: "textfield",
    "display-required": 1,
    "display-fieldlabel": "Last Name",
    "database-label": "last_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9._\\-\\s]*",
  },
  "1718616976561-email": {
    elementid: 1718616976561,
    elementtype: "email",
    "display-required": 1,
    "display-fieldlabel": "Email id",
    "database-label": "email_id",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-pattern": "^[a-zA-Z0-9@._+-s]*$",
  },
  "1718617011709-textfield": {
    elementid: 1718617011709,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 1",
    "database-label": "address",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617014275-textfield": {
    elementid: 1718617014275,
    elementtype: "textfield",
    "display-fieldlabel": "Address line 2",
    "database-label": "address2",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617031258-textfield": {
    elementid: 1718617031258,
    elementtype: "textfield",
    "display-fieldlabel": "Relation",
    "database-label": "relation",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617038957-textfield": {
    elementid: 1718617038957,
    elementtype: "textfield",
    "display-fieldlabel": "State",
    "database-label": "state",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718617041258-textfield": {
    elementid: 1718617041258,
    elementtype: "textfield",
    "display-fieldlabel": "City",
    "database-label": "city",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
  },
  "1718616984561-phoneNumber": {
    elementid: 1718616984561,
    elementtype: "phoneNumber",
    "display-fieldlabel": "Mobile No.",
    "database-label": "contact",
    "display-labelposition": "top",
    "display-placeholder": "Enter",
    "validation-maxlength": "10",
    "validation-pattern": "^[0-9+\\-\\s()]*$",
  },
};
